import ProjectAuthorsEdit from "../../ProjectAuthorsEdit";
import React, {useMemo} from "react";
import {useController} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {API} from "@brg/api";

const DesignerSelect = (props: any) => {
    const {i18n: {language}} = useTranslation();
    const { name, onChange } = props;
    const {field: {value}} = useController({name});

    const transformedValue = useMemo(() => {
        const shouldWrapInArray = !Array.isArray(value);
        const translatedValue = API.toLang(value, language);
        return shouldWrapInArray ? [translatedValue] : translatedValue;
    }, [value, language]);

    return (    
        <ProjectAuthorsEdit
            {...props}
            value={transformedValue}
            onChange={onChange}
        />
    )
}

export default DesignerSelect;import ProjectAuthorsEdit from "../../ProjectAuthorsEdit";
import React, {useMemo} from "react";
import {useController} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {API} from "@brg/api";

const DesignerSelect = (props: any) => {
    const {i18n: {language}} = useTranslation();
    const { name, onChange } = props;
    const {field: {value}} = useController({name});

    const transformedValue = useMemo(() => {
        const shouldWrapInArray = !Array.isArray(value);
        const translatedValue = API.toLang(value, language);
        return shouldWrapInArray ? [translatedValue] : translatedValue;
    }, [value, language]);

    return (    
        <ProjectAuthorsEdit
            {...props}
            value={transformedValue}
            onChange={onChange}
        />
    )
}

export default DesignerSelect;